import { useConfig } from "$global-providers/config-provider/provider";
import {
  type AppState,
  Auth0Provider as BaseAuth0Provider,
} from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

export const ELEPHANT_API_AUTH0_AUDIENCE = "https://elephantprimarycare.com";

export const Auth0Provider = ({ children }) => {
  const navigate = useNavigate();
  const {
    auth0: { clientId, domain },
  } = useConfig();

  const onRedirectCallback = (appState: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <BaseAuth0Provider
      domain={domain}
      clientId={clientId}
      redirectUri={`${window.location.origin}/auth0/callback`}
      onRedirectCallback={onRedirectCallback}
      cacheLocation={"localstorage"}
      audience={ELEPHANT_API_AUTH0_AUDIENCE}
      useRefreshTokens
    >
      {children}
    </BaseAuth0Provider>
  );
};
